export const locale = {
    lang: 'nl',
    data: {
      'DISPATCH': {
        'ENCUESTA_PILOTO': 'Proefenquête',
        'ENCUESTA_PILOTO_ENVIO': 'Pilootonderzoek verzenden',
        'ENCUESTA_LANZAMIENTO': 'Lanceerbevestiging',
        'BTN': 'Kopieer enquêtesleutel',
        ////*******Tab Crear Encuestas********************************///
        'CREAR_ENCUESTA': 'Maak een enquête',
        'ENCUESTA_DEMO': 'Proefenquête',
        'BOTON_CREAR_ENCUESTA': 'Genereren van enquête',
        'STAP': 'Stap voltooid',
        'SEE_TI': 'Bekijk de technische vereisten',
        'CLAVE': 'Toegangssleutel',
        'ACCESO': 'Sleutel',
        'NOFECHA': 'U kunt deze actie niet uitvoeren omdat er nog geen lanceringsdatum is',
        'LABEL01': 'Kopieer en plak de toegangssleutel, in de proefenquête',
        'LABEL02': 'De verzending van de enquête is bevestigd',
        'LABEL03': 'E-mail',
        'LABEL04': 'Verzending van de proefenquête',
        'LABEL05': 'Er gaat iets mis',
        'LABEL06': 'De proefenquête is correct verzonden',
        'LABEL07': 'Verplicht veld',
        'LABEL08': 'Complete stap',
        'LABEL09': 'De gebruikers van de enquête zijn uitgeput',
        'CONFIRMAR_ENVIO': 'Bevestig de verzending van e-mails',
        'DES_CONFIRMAR_ENVIO': 'Ontkenning van de verzending van e-mails',
        'CONFIRMAR_ENVIO_35': 'Bevestig de verzending van de uitnodiging voor de enquête',
        'SI_CONFIRMAR_ENVIO': 'Ja',
        'NO_CONFIRMAR_ENVIO': 'Nee',
        'CHANGE-OPTIONS': 'Wijzig mailopties',
        'NO_ENVIO_CORREO': 'Er wordt geen post verstuurd',
        'SI_ENVIO_CORREO': 'De mails worden verstuurd',
        'EN_CASO': 'Door NO te selecteren, moet alle communicatie over de enquête buiten het platform worden afgehandeld. Er worden geen e-mails naar de gebruikers gestuurd.',
        'AUTOLOG_35': 'Koppeling voor automatisch inloggen op de enquête:',
        'TITULO': 'In dit gedeelte kunt u een testrit maken van de enquête:',
        'LINK':'1. Ga naar de volgende link:',
        'LINKNORMA35':'1. 2. Ga naar de volgende link voor de enquête van',
        'CLAVE_ENCUESTA':'2. Kopieer deze testsleutel:',
        'INSTRUCCION3':'3.Plak de sleutel in de wachtwoordcel',
        'INSTRUCCION4':'4. Klik op inloggen',
        'TEXTO_CONFIRMAR': 'Bevestig dat de communicatie met de gebruikers (uitnodiging en herinneringen) via e-mail plaatsvindt',
        'TEXTO_CONFIRMAR2': 'In het geval dat U NIET wilt dat de MAILS worden verzonden, hoeft U alleen maar te klikken en de stap te sluiten',
        'TITULO_PILOTO': 'In dit gedeelte kunt u de uitnodigingsmail voor deelname naar maximaal vijf verschillende medewerkers sturen om een test te maken van de ontvangst van de mail en de visualisatie van de enquête, voorafgaand aan de daadwerkelijke lancering van de enquête:',
        'INSTRUCCION_PILOTO':'1. Voer de e-mails in en selecteer de taal waarin u de uitnodiging wilt ontvangen',
        'INSTRUCCION_PILOTO2':'2. 2. Klik op de knop Verzenden',
        'SELLANG': 'Selecteer een taal',
        'MENSAJES':{
           'MSN_INGR_COD':'<span> Om te bevestigen dat er geen uitnodigings- of herinneringsmails worden verstuurd, voert u de code in het tekstvak in het rood in',
           'MSN_INGR_COD2': '</span>',
           'MSN_CHANGE-CONFI': 'De configuratie is gewijzigd',

        'BTN_MODALES':{
          'CONFIRMAR': 'Bevestigen',
          'EXIT': 'Exit',
        }
        },
        'URL35':{ // Sive unicamente para dispatch de la norma 35
            'MAS50': 'meer 50',
            'MENOS50': 'minder 50',
            'CORTA': 'Algemene URL',
        },

        'CERTIFICAR2':{ // Sive unicamente para crear encuesta de certificar 2.0
          'LINK':'1. Ga naar de volgende link:',
          'CLAVE_ENCUESTA':'2. 2. Kopieer een van de sleutels die in de sectie demo-gebruikers zijn gegenereerd',
          'INSTRUCCION3':'3. Plak de sleutel in de wachtwoordcel',
          'INSTRUCCION4':'4. Klik op inloggen',
          'USERSDEMO': 'Demo-gebruikers',
          'GEBRUIKERS': 'Gebruiker',
          'CLAVE': 'Sleutel',
          'ESTATUS': 'Status',
          'ESTATUS-USER-ASIGNA': 'Toegewezen',
          'INST_UPD_URL_NAME': 'Pas de ShortUrl aan door tot 6 tekens tekst te typen die vertrouwd is voor uw gebruikers.',
          'BTN_UPD_GUARDA': 'Opslaan',
          'BTN_UPD_CAN': 'Annuleren',
          'CUS_SHOI_URL': 'Pas de URL van de enquête aan',
          'MODAL_ACTU_CUS_SHOI_URL': 'De naam in de url bijwerken',
          'ACTU_CUS_SHOI_URL_OK': 'De naam in de url is correct bijgewerkt',
          'ACTU_CUS_SHOI_URL_FALSE':'De naam in de url bestaat al',

        },


        'ALERT':{
            'HEADER': 'Info',
            'MESSAGE_CON': '¿U wilt de verzending van e-mails aan gebruikers bevestigen?',
            'MESSAGE': '¿Wilt u de verzending van e-mails naar uw medewerkers bevestigen?',
            'MESSAGE_DESCON': '¿Weet u zeker dat u de verzending van e-mails naar gebruikers niet wilt bevestigen?',
            'BTN_CANCEL': 'Nee, annuleer',
            'BTN_CONFIRM': 'Oké, stuur',
            'BTN_NO_CONFIRM': 'Nee, stuur',
            'BTN_SI_CONFIRM': 'Ja, stuur',
            'BTN_NO_CANCEL': 'annuleren',
            'BTN_OK': 'Ok',
            'ERROR_01': 'Je hebt nog geen uitnodiging gestuurd',
            'SINCOLABS': 'U kunt de uitnodiging voor de enquête nog niet versturen, u moet de deelnemerslijst van het bedrijf al eerder uploaden',
            'SINLANG': 'U hebt nog geen taal geselecteerd voor een of meer ingevoerde e-mailadressen',
            'ERRMAIL': 'De ingevoerde e-mail heeft niet de juiste syntaxis, controleer deze en voer deze opnieuw in'
        }
      },
    'PULSE':{
            'LABEL01': 'Stuur de enquête naar uw medewerkers',
    }
    }
};
